import { Form, Select } from "antd";

export default function Status(props) {
  return (
    <Form.Item
      {...props}
      name="blocked"
      className="w-full"
      label="Status"
      rules={[
        {
          required: true,
          message: "Status is required",
        },
      ]}
    >
      <Select
        placeholder="Select one"
        className="w-full"
        options={[
          {
            label: "Blocked",
            value: true,
          },
          {
            label: "Active",
            value: false,
          },
        ]}
      />
    </Form.Item>
  );
}
